module.exports = __webpack_public_path__ + "static/media/pickled_tomatoes.610b6a6f.png";